import { Link } from "react-router-dom";
import { LOGO_URL, BOT_NAME } from "@/config";

export const Logo = ({ size = "md", withWordmark = true }) => {
  const dims = size === "lg" ? "h-12 w-12" : size === "sm" ? "h-8 w-8" : "h-9 w-9";
  return (
    <Link
      to="/"
      className="group flex items-center gap-3"
      data-testid="brand-logo"
      aria-label="Xevon home"
    >
      <span className="relative">
        <img
          src={LOGO_URL}
          alt="Xevon logo"
          width={size === "lg" ? 48 : size === "sm" ? 32 : 36}
          height={size === "lg" ? 48 : size === "sm" ? 32 : 36}
          decoding="async"
          className={`${dims} rounded-full border border-white/15 object-cover transition-transform duration-500 group-hover:scale-105`}
        />
        <span className="absolute inset-0 rounded-full bg-white/0 transition-colors duration-500 group-hover:bg-white/5" />
      </span>
      {withWordmark && (
        <span className="font-display text-lg font-semibold tracking-[0.18em] text-paper-100">
          {BOT_NAME.toUpperCase()}
        </span>
      )}
    </Link>
  );
};
